var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLighting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2V3.35M3.35 15.5H2M6.725 6.725L5.91487 5.91487M24.275 6.725L25.0853 5.91487M29 15.5H27.65M12.8 17.525H18.2M15.5 17.525V24.275M20.225 22.0798C22.269 20.6094 23.6 18.2102 23.6 15.5C23.6 11.0265 19.9735 7.4 15.5 7.4C11.0265 7.4 7.4 11.0265 7.4 15.5C7.4 18.2102 8.73101 20.6094 10.775 22.0798V24.68C10.775 26.1921 10.775 26.9482 11.0693 27.5258C11.3281 28.0338 11.7412 28.4469 12.2492 28.7057C12.8268 29 13.5829 29 15.095 29H15.905C17.4171 29 18.1732 29 18.7508 28.7057C19.2588 28.4469 19.6719 28.0338 19.9307 27.5258C20.225 26.9482 20.225 26.1921 20.225 24.68V22.0798Z",
    stroke: "#464555",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2V3.35M3.35 15.5H2M6.725 6.725L5.91487 5.91487M24.275 6.725L25.0853 5.91487M29 15.5H27.65M12.8 17.525H18.2M15.5 17.525V24.275M20.225 22.0798C22.269 20.6094 23.6 18.2102 23.6 15.5C23.6 11.0265 19.9735 7.4 15.5 7.4C11.0265 7.4 7.4 11.0265 7.4 15.5C7.4 18.2102 8.73101 20.6094 10.775 22.0798V24.68C10.775 26.1921 10.775 26.9482 11.0693 27.5258C11.3281 28.0338 11.7412 28.4469 12.2492 28.7057C12.8268 29 13.5829 29 15.095 29H15.905C17.4171 29 18.1732 29 18.7508 28.7057C19.2588 28.4469 19.6719 28.0338 19.9307 27.5258C20.225 26.9482 20.225 26.1921 20.225 24.68V22.0798Z",
    stroke: "#464555",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighting);
export default __webpack_public_path__ + "static/media/lighting.a8da5b131844b584d3abecc9e1fae79a.svg";
export { ForwardRef as ReactComponent };